import React from "react";
import { useEffect, useState } from "react";
import { CustomCard, Title } from "../../Utils/UI/Text";
import { getEmissionFactorsLogic } from "../Application/EmissionFactors.logic";
import EmissionFactorsBoard from "./EmissionFactorsBoard";

const EmissionFactorsTable = () => {
  const [emissionFactors, setEmissionFactors] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchEmissionFactors = async (params = {}) => {
    try {
      setLoading(true);
      const { count, resources } = await getEmissionFactorsLogic(params);
      setEmissionFactors(resources || []);
      setTotalCount(count || 0);
    } catch (error) {
      console.error("Error al cargar emission factors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmissionFactors();
  }, []);

  return (
    <>
      <Title children="Factores de Emisión" />
      <CustomCard>
        <EmissionFactorsBoard
          emissionFactors={emissionFactors}
          getEmissionFactors={fetchEmissionFactors}
          totalEmissionFactors={totalCount}
          initialLoading={loading}
        />
      </CustomCard>
    </>
  );
};

export default EmissionFactorsTable;